export enum ActionPermissionEnum {
  EditGlobalLayout = 1,
  EditGlobalFilter = 2,
  NewProject = 3,
  DeleteProject = 4,
  CompanyMergeWizard = 5,
  EditLayoutVisibility = 6,
  EditWritingTemplate = 7,
  EditReportTemplate = 8,
  EditAllUserVariables = 9,
  Superuser = 10,
  ShowIdColumns = 11,
  EditEntitiesWithExternalId = 12,
  CanActivateLlDebugLog = 13,
  CanRemoveLayoutFilter = 14,
  CanViewLoggings = 15,
  CreateUserByApi = 16,
  CanViewAdminUsers = 17,
}
